// extracted by mini-css-extract-plugin
export default {"text":"SmallTitle_text__WEQqw"};